/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 16/06/2026 18:39
 *
 */

export const environment = {
  production: true,
  appConfig: 'app-labo-alwayson',
  imgLogoPath: 'https://assets.integrix.lu/img/logos/integrix-vigiguard.svg',
  titleAppName: 'Vigiguard',
  manualLink: '',
};
